import educationSlide1Img from './educationSlide1.webp';
import educationSlide2Img from './educationSlide2.webp';
import educationSlide3Img from './educationSlide3.webp';
import employersSlide1Img from './employersSlide1.webp';
import employersSlide2Img from './employersSlide2.webp';
import employersSlide3Img from './employersSlide3.webp';
import seniorsSlide1Img from './seniorsSlide1.webp';
import seniorsSlide2Img from './seniorsSlide2.webp';
import seniorsSlide3Img from './seniorsSlide3.webp';
import healthcareSlide1Img from './healthcareSlide1.webp';
import healthcareSlide2Img from './healthcareSlide2.webp';
import healthcareSlide3Img from './healthcareSlide3.webp';
import faithSlide1Img from './faithSlide1.webp';
import faithSlide2Img from './faithSlide2.webp';
import faithSlide3Img from './faithSlide3.webp';

export const educationSlide1: string = educationSlide1Img;
export const educationSlide2: string = educationSlide2Img;
export const educationSlide3: string = educationSlide3Img;
export const employersSlide1: string = employersSlide1Img;
export const employersSlide2: string = employersSlide2Img;
export const employersSlide3: string = employersSlide3Img;
export const seniorsSlide1: string = seniorsSlide1Img;
export const seniorsSlide2: string = seniorsSlide2Img;
export const seniorsSlide3: string = seniorsSlide3Img;
export const healthcareSlide1: string = healthcareSlide1Img;
export const healthcareSlide2: string = healthcareSlide2Img;
export const healthcareSlide3: string = healthcareSlide3Img;
export const faithSlide1: string = faithSlide1Img;
export const faithSlide2: string = faithSlide2Img;
export const faithSlide3: string = faithSlide3Img;
